import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Icon as ZinniaIcon, Typography, Colors, } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { RichText } from '../RichText';
const Styles = labelStyles('FeaturesSection', {
    root: (backgroundColor, textColor) => css({
        backgroundColor: Colors[backgroundColor],
        color: Colors[textColor],
        padding: '64px 30px',
        '@media (max-width: 960px)': {
            padding: '80px 30px',
        },
    }),
    content: css({
        display: 'grid',
        alignItems: 'flex-start',
        textAlign: 'left',
        justifyContent: 'flex-start',
        gap: '50px 30px',
        maxWidth: '1170px',
        margin: 'auto',
        gridTemplateColumns: 'repeat(3, 1fr)',
        '@media (max-width: 960px)': {
            gridTemplateColumns: '1fr',
        },
    }),
    heading: css(Object.assign(Object.assign({}, Typography.pageHeader9), { textAlign: 'start', marginTop: '15px', '@media (min-width: 660px)': Object.assign(Object.assign({}, Typography.pageHeader9), { marginBottom: '10px' }) })),
    description: css(Object.assign(Object.assign({}, Typography.paragraph1Short), { marginTop: '10px', textAlign: 'start' })),
});
export function FeaturesSection({ features, tag, backgroundColor, textColor, }) {
    const Tag = tag;
    return (_jsx("section", Object.assign({ css: Styles.root(backgroundColor, textColor) }, { children: _jsx("div", Object.assign({ css: Styles.content }, { children: (features || []).map((feature, index) => (_jsxs("div", { children: [_jsx(ZinniaIcon, { name: feature.icon, color: feature.iconColor, size: 50 }), _jsx(Tag, Object.assign({ css: Styles.heading }, { children: feature.heading })), _jsx("div", Object.assign({ css: Styles.description }, { children: _jsx(RichText, { html: feature.description }) }))] }, `${feature.heading}-${index}`))) })) })));
}
//# sourceMappingURL=FeaturesSection.js.map